module.exports = __webpack_public_path__ + "static/media/Ab6.88c79ec8.mp3";


//////////////////
// WEBPACK FOOTER
// ./node_modules/jazzband/demo/samples/piano/Ab6.mp3
// module id = 184
// module chunks = 0